import { scrollToTop } from 'core/utils/html';
import React, { useState } from 'react';
import Service52WeeksConfig from './Service52WeeksConfig';
import Service52WeeksRules from './Service52WeeksRules';
import { useAuth } from '../auth/AuthProvider';

type IService52WeeksStartProps = {};

const Service52WeeksStart: React.FC<IService52WeeksStartProps> = () => {
    const { isLoggedIn, openAuthModal } = useAuth();
    const [stage, setStage] = useState<'rules' | 'config'>('rules');

    const handleStartButtonClick = () => {
        if (isLoggedIn) {
            setStage('config');
            scrollToTop();
        } else {
            openAuthModal('login');
        }
    };

    if (stage === 'config') {
        return <Service52WeeksConfig />;
    } else {
        return <Service52WeeksRules label="Начать" onClick={handleStartButtonClick} />;
    }
};

export default Service52WeeksStart;
